import React, { useContext, useEffect, useState } from 'react'
import { LoadingSpinner } from '../Loaders'
import { commonHeadersWeb } from 'src/consumer/services'
import { LocalizationContext } from 'src/consumer/context/LocalizationContext'

const EventBooking = React.lazy(() => import('../EventBooking/index'))

export default function EventBookingWrapperForWebview() {
  const [token, setToken] = useState()
  const [headers, setHeaders] = useState()
  const { refreshLocaleData } = useContext(LocalizationContext)

  useEffect(() => {
    // call iOS interface methods
    try {
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.iosBridge
      ) {
        window.webkit.messageHandlers.iosBridge.postMessage({ method: 'setAumhumRequestHeaders' })
        window.webkit.messageHandlers.iosBridge.postMessage({ method: 'getUserToken' })
      }
    } catch (error) {
      console.error('Got error in calling iOS interface method:', error)
    }

    // Exposing setting methods for iOS to use
    window.setToken = function (token) {
      try {
        console.log(token)
        localStorage.setItem('token', token)
        setToken(token)
      } catch (error) {
        console.error('Error setting token:', error)
      }
    }

    window.setAumhumRequestHeaders = function (headers) {
      try {
        console.log('headers from IOS is ' + headers)
        replaceHeadersAndCallSetupAPI(headers)
      } catch (error) {
        console.error('Error setting Headers:', error)
      }
    }
    // Call Android interface methods

    if (window.Android && typeof window.Android.getUserToken === 'function') {
      const tokenFromAndroid = window.Android.getUserToken()
      console.log('user token from android is  ' + tokenFromAndroid)
      setToken(tokenFromAndroid)
      localStorage.setItem('token', tokenFromAndroid)
    }

    if (window.Android && typeof window.Android.setAumhumRequestHeaders === 'function') {
      const headers = window.Android.setAumhumRequestHeaders()
      console.log('headers from token from android  ' + headers)
      replaceHeadersAndCallSetupAPI(headers)
    }

    function replaceHeadersAndCallSetupAPI(headers) {
      const parsedHeaders = JSON.parse(headers)
      localStorage.setItem('countryCode', parsedHeaders['ef-user-country-code'])
      localStorage.setItem('languageCode', parsedHeaders['ef-app-language'])
      sessionStorage.setItem('languageCode', parsedHeaders['ef-app-language'])

      for (let key of Object.keys(parsedHeaders)) {
        commonHeadersWeb[key] = parsedHeaders[key] || commonHeadersWeb[key]
      }
      setHeaders(headers)
      refreshLocaleData()
    }
  }, [])

  if (token && headers) {
    return <EventBooking openedAsWebview={true} />
  } else {
    return <LoadingSpinner bgColor="#7A52B5" />
  }
}
